import { Link, useParams } from "react-router-dom";
import ArrowLeftIcon from "src/components/icons/common/arrow-left";
import AgentHead from "../AgentHead";
import { AgentName } from "..";
import AgentInfo from "../AgentInfo";
import { useRef } from "react";
import {
  companyDiligenceAgent,
  corporateVentureAgent,
  marketStrategyAgent,
  productEngAgent,
  technologyRndAgent,
  financeStrategyAgent,
  fundRaisingAgent,
  legalCompliamceAgent,
  portfolioSupportAgent,
  reportAnythingAgent,
  priorArtAgent,
  patentFileWrapperAgent,
  ftoAgent,
  patentLandscapeAgent,
  patentLicensingAgent,
  customer360AgentChat,
} from "./sample-data";
import ReportConversation from "src/pages/my-account/my-agent-reports/my-reports/ReportConversation";
import customer360icon from "../landing/_assets/AgentLanding-Icons/Customer360.svg";

export default function SampleChat() {
  const chatRef = useRef<HTMLInputElement>(null);

  const { agent } = useParams();

  const agentMapping: any = {
    "company-diligence-agent": {
      agentChat: companyDiligenceAgent,
      agentTitle: "Company Diligence Agent",
    },

    "technology-agent": {
      agentChat: technologyRndAgent,
      agentTitle: "Technology & R&D",
    },

    "finance-strategy-agent": {
      agentChat: financeStrategyAgent,
      agentTitle: "Finance & Strategy Agent",
    },

    "market-strategy-agent": {
      agentChat: marketStrategyAgent,
      agentTitle: "Market Strategy Agent",
    },

    "corporate-venture-capital-agent": {
      agentChat: corporateVentureAgent,
      agentTitle: "Corporate Venture Capital Agent",
    },

    "product-engineering-agent": {
      agentChat: productEngAgent,
      agentTitle: "Product & Engineering Agent",
    },
    "fundraising-strategy-agent": {
      agentChat: fundRaisingAgent,
      agentTitle: "Fund Raising Strategy Agent",
    },
    "legal-compliance-agent": {
      agentChat: legalCompliamceAgent,
      agentTitle: "Legal & Compliance Agent",
    },
    "portfolio-support-agent": {
      agentChat: portfolioSupportAgent,
      agentTitle: "Portfolio Support Agent",
    },
    "report-on-anything-agent": {
      agentChat: reportAnythingAgent,
      agentTitle: "Report on Anything Agent",
    },
    "prior-art-agent": {
      agentChat: priorArtAgent,
      agentTitle: "Prior Art Agent",
    },
    "prosecution-history-agent": {
      agentChat: patentFileWrapperAgent,
      agentTitle: "Prosecution History Agent",
    },
    "patent-licensing-agent": {
      agentChat: patentLicensingAgent,
      agentTitle: "Patent Licensing Agent",
    },
    "patent-landscape-agent": {
      agentChat: patentLandscapeAgent,
      agentTitle: "Patent Landscape Agent",
    },
    "fto-agent": {
      agentChat: ftoAgent,
      agentTitle: "FTO Agent",
    },

    "customer-360-agent": {
      agentChat: customer360AgentChat,
      agentTitle: "Customer 360 Agent",
    },

    // "marketing-agent":{
    //   agentChat:
    //   agentTitle:"Marketing Agent"
    // }

  };

  return (
    <>
      <div className="px-0 md:px-3 w-full mx-auto h-full">
        <div className="flex justify-start items-center mt-3">
          <Link to="/ai-agent/landing">
            <p className="mr-4 text-secondary-800 flex items-center">
              <ArrowLeftIcon className="mr-1" />
              Back
            </p>
          </Link>
        </div>
        <AgentHead
          agentName={`${agentMapping[agent || "company-diligence-agent"]?.agentTitle} Sample Chat`}
        />
        <div className="flex flex-col gap-y-3 lg:flex-row lg:gap-y-0 gap-x-5 lg:gap-x-2">
          {/* <div>
            <AgentInfo agent={""} />
          </div> */}
          <div className="flex-auto relative flex flex-col gap-2 max-w-[780px] mx-auto min-h-[100vh]">
            <div className="flex flex-row flex-auto justify-center">
              <div
                ref={chatRef}
                className=" p-3 pt-0 w-full max-h-[calc(100vh-244px)] overflow-y-auto pn_scroller "
              >
                <ReportConversation
                  loading={false}
                  reports={agentMapping[agent || "company-diligence-agent"]?.agentChat}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
